var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStores(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stores-Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821",
    transform: "translate(-4811.367 -2594.475)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4499",
    "data-name": "Rectangle 4499",
    width: 24,
    height: 24,
    transform: "translate(4811.367 2594.475)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(4752.207 2597.385)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M6.737,18.918C6.461,18.643,0,12.124,0,7.16a7.159,7.159,0,1,1,14.318,0c0,4.964-6.461,11.482-6.737,11.758a.611.611,0,0,1-.422.173A.6.6,0,0,1,6.737,18.918ZM1.194,7.16c0,3.792,4.541,8.947,5.965,10.471,1.424-1.523,5.965-6.682,5.965-10.471a5.965,5.965,0,1,0-11.931,0Zm2.384,0a3.579,3.579,0,1,1,3.581,3.581A3.584,3.584,0,0,1,3.578,7.16Zm1.194,0A2.386,2.386,0,1,0,7.159,4.776,2.39,2.39,0,0,0,4.772,7.16Z",
    transform: "translate(64.001 -0.001)",
    fill: "#65676a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStores);
export default __webpack_public_path__ + "static/media/icon_stores.3ea06681532216d1b1e95d6e8e2493fe.svg";
export { ForwardRef as ReactComponent };